<template>
  <section class="box">
    <b-field grouped group-multiline>
      <b-field label="Código de barras" expanded>
        <b-input
          type="number"
          icon="barcode"
          placeholder="Código de barras"
          v-model="producto.codigo"
        ></b-input>
      </b-field>
      <b-field label="Nombre" expanded>
        <b-input
          placeholder="Nombre o descripción del producto"
          v-model="producto.nombre"
        ></b-input>
      </b-field>
      <b-field label="Unidad" expanded>
        <b-select
          class="wide"
          placeholder="Unidad"
          icon="tag-multiple"
          v-model="producto.unidad"
        >
          <option
            v-for="[value, title] in unidades"
            :key="value"
            :value="value"
          >
            {{ title }}
          </option>
        </b-select>
      </b-field>
      <b-field label="Precio compra" expanded>
        <b-input
          step="any"
          icon="currency-usd"
          type="number"
          placeholder="Precio de compra"
          v-model="producto.precioCompra"
        ></b-input>
      </b-field>
    </b-field>

    <b-field class="mt-5" grouped group-multiline>
      <b-field label="Precio venta" expanded>
        <b-input
          step="any"
          icon="currency-usd"
          type="number"
          placeholder="Precio de venta"
          v-model="producto.precioVenta"
          :min="producto.precioCompra"
        ></b-input>
      </b-field>

      <b-field label="Precio venta 2" expanded>
        <b-input
          step="any"
          icon="currency-usd"
          type="number"
          placeholder="Precio de venta 2"
          v-model="producto.precioVenta2"
          :min="producto.precioCompra"
        ></b-input>
      </b-field>

      <b-field label="Precio venta 3" expanded>
        <b-input
          step="any"
          icon="currency-usd"
          type="number"
          placeholder="Precio de venta 3"
          v-model="producto.precioVenta3"
          :min="producto.precioCompra"
        ></b-input>
      </b-field>

      <b-field label="Precio venta 4" expanded>
        <b-input
          step="any"
          icon="currency-usd"
          type="number"
          placeholder="Precio de venta 4"
          v-model="producto.precioVenta4"
          :min="producto.precioCompra"
        ></b-input>
      </b-field>

      <b-field label="Precio venta 5" expanded>
        <b-input
          step="any"
          icon="currency-usd"
          type="number"
          placeholder="Precio de venta 5"
          v-model="producto.precioVenta5"
          :min="producto.precioCompra"
        ></b-input>
      </b-field>

      <b-field label="Precio venta 6" expanded>
        <b-input
          step="any"
          icon="currency-usd"
          type="number"
          placeholder="Precio de venta 6"
          v-model="producto.precioVenta6"
          :min="producto.precioCompra"
        ></b-input>
      </b-field>

      <b-field label="Precio venta 7" expanded>
        <b-input
          step="any"
          icon="currency-usd"
          type="number"
          placeholder="Precio de venta 7"
          v-model="producto.precioVenta7"
          :min="producto.precioCompra"
        ></b-input>
      </b-field>

      <b-field label="Existencia" expanded v-if="!editar">
        <b-numberinput
          min="1"
          :max="maxCantidadProducto"
          step="0.01"
          type="is-info"
          placeholder="Existencia"
          v-model="producto.existencia"
        >
        </b-numberinput>
      </b-field>
    </b-field>
    <br />
    <b-field grouped group-multiline>
      <b-field>
        <b-switch v-model="producto.vendidoMayoreo" type="is-info">
          ¿Vendido al mayoreo?
        </b-switch>
      </b-field>

      <b-field label="Precio mayoreo" expanded v-if="producto.vendidoMayoreo">
        <b-input
          step="any"
          icon="currency-usd"
          type="number"
          placeholder="Precio de venta al mayoreo"
          v-model="producto.precioMayoreo"
          :min="producto.precioCompra"
        ></b-input>
      </b-field>

      <b-field label="Cantidad mayoreo" expanded v-if="producto.vendidoMayoreo">
        <b-numberinput
          min="1"
          :max="maxCantidadProducto"
          type="is-info"
          placeholder="Cantidad para aplicar mayoreo"
          v-model="producto.cantidadMayoreo"
        >
        </b-numberinput>
      </b-field>
    </b-field>
    <br />
    <b-field grouped group-multiline>
      <b-field label="Selecciona un proveedor">
        <b-select
          placeholder="Proveedor"
          icon="factory"
          v-model="producto.proveedor"
        >
          <option
            v-for="proveedor in proveedores"
            :key="proveedor.id"
            :value="proveedor.id"
          >
            {{ proveedor.nombre }}
          </option>
        </b-select>
      </b-field>
      <b-field label="Almacén (opcional)">
        <b-select placeholder="Almacén" icon="warehouse" v-model="producto.idAlmacen">
          <option :value="null">Sin almacén</option>
          <option
            v-for="a in almacenes"
            :key="a.id"
            :value="a.id"
            v-bind:style="{ backgroundColor: a.color + '22', borderLeft: '4px solid ' + a.color }"
          >
            {{ a.nombre }} ({{ a.cod }})
          </option>
        </b-select>
      </b-field>
    </b-field>

    <!-- Paquetes section -->
    <div v-if="editar" class="mt-5">
      <hr />
      <h3 class="title is-5">Productos empaquetados</h3>

      <div v-if="paquetes.length > 0">
        <div
          v-for="paq in paquetes"
          :key="paq.id"
          class="box paquete-item mb-2"
        >
          <div class="level is-mobile">
            <div class="level-left">
              <div>
                <strong>{{ paq.nombre_paquete }}</strong>
                <span class="has-text-grey ml-1 is-size-7">{{
                  paq.codigo_paquete
                }}</span>
                <span class="tag is-info is-light ml-2"
                  >Stock: {{ paq.existencia_paquete }}</span
                >
                <span class="has-text-grey is-size-7 ml-2">
                  1 {{ paq.nombre_paquete }} (producto empaquetado) =
                  {{ paq.cantidad_base }}
                  {{ producto.unidad || producto.nombre }} del producto detal
                </span>
                <!-- Indicación operativa: es lo que hace el sistema al vender de más -->
                <div class="is-size-7 has-text-success" v-if="paq.unidades_por_envase >= 1">
                  Al vender más de lo que haya del producto detal se abrirá 1
                  {{ paq.nombre_paquete }} (producto empaquetado) y sumará
                  {{ paq.cantidad_base }} {{ producto.unidad || "unidad" }} del producto
                  detal.
                </div>
                <div class="is-size-7 has-text-danger" v-else>
                  ⚠ Vinculación inválida: 1 producto empaquetado
                  {{ paq.nombre_paquete }} rinde {{ paq.unidades_por_envase }}
                  {{ producto.unidad || "unidad" }} del producto detal. Al vender de más NO
                  se podrá reponer. Corrige con el botón "Corregir".
                </div>
              </div>
            </div>
            <div class="level-right">
              <b-button
                type="is-warning"
                size="is-small"
                icon-left="pencil"
                class="mr-2"
                @click="editarPaquete(paq)"
              ></b-button>
              <b-button
                type="is-danger"
                size="is-small"
                icon-left="delete"
                @click="eliminarPaquete(paq.id)"
              ></b-button>
            </div>
          </div>

          <!-- Corrección explícita de la relación: se ve el antes/después antes de guardar -->
          <div
            v-if="paqueteEnEdicion && paqueteEnEdicion.id === paq.id"
            class="box has-background-light mt-2"
          >
            <p class="is-size-7 has-text-grey mb-2">
              Producto detal (el que se vende suelto) y producto empaquetado (el que se
              abre). Si están invertidos, usa "Intercambiar".
            </p>
            <b-field grouped group-multiline>
              <b-field label="Producto detal" expanded>
                <b-input :value="paqueteEnEdicion.nombre_base" readonly></b-input>
              </b-field>
              <b-field label="Producto empaquetado" expanded>
                <b-input
                  :value="paqueteEnEdicion.nombre_paquete"
                  readonly
                ></b-input>
              </b-field>
            </b-field>
            <b-field grouped group-multiline>
              <b-field label="Unidades del producto detal por producto empaquetado" expanded>
                <b-input
                  type="number"
                  step="0.01"
                  min="0.01"
                  v-model="paqueteEnEdicion.cantidad_base"
                ></b-input>
              </b-field>
              <b-field label="Cantidad de productos empaquetados" expanded>
                <b-input
                  type="number"
                  step="1"
                  min="1"
                  v-model="paqueteEnEdicion.cantidad_paquete"
                ></b-input>
              </b-field>
            </b-field>
            <div class="is-size-7 mb-2">
              Resultado: 1 producto empaquetado {{ paqueteEnEdicion.nombre_paquete }} =
              {{
                unidadesPorEnvaseDe(
                  paqueteEnEdicion.cantidad_base,
                  paqueteEnEdicion.cantidad_paquete
                )
              }}
              {{ producto.unidad || "unidad" }} del producto detal
              {{ paqueteEnEdicion.nombre_base }}
            </div>
            <div class="buttons">
              <b-button
                type="is-warning"
                size="is-small"
                icon-left="swap-horizontal"
                @click="intercambiarDetalleYEnvase"
              >
                Intercambiar detal ↔ empaquetado
              </b-button>
              <b-button
                type="is-primary"
                size="is-small"
                icon-left="content-save"
                @click="guardarEdicionPaquete"
              >
                Guardar corrección
              </b-button>
              <b-button size="is-small" @click="cancelarEdicionPaquete">
                Cancelar
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <b-message v-else type="is-info" size="is-small">
        No hay productos empaquetados registrados para este producto.
      </b-message>

      <hr />
      <h4 class="title is-6">Agregar producto empaquetado</h4>

      <b-field label="Buscar producto para usar como producto empaquetado">
        <b-autocomplete
          v-model="nuevoPaquete.busqueda"
          placeholder="Escribe el nombre del producto..."
          :data="productosParaPaquete"
          field="nombre"
          @input="buscarProductosParaPaquete"
          @select="seleccionarProductoPaquete"
          expanded
          :clearable="true"
        >
          <template slot-scope="props">
            <span>{{ props.option.nombre }}</span>
            <span class="has-text-grey is-size-7"
              >&mdash; {{ props.option.codigo }}</span
            >
          </template>
        </b-autocomplete>
      </b-field>

      <div v-if="nuevoPaquete.id_paquete" class="box">
        <p>
          <strong>{{ nuevoPaquete.nombre_paquete }}</strong>
          <span class="has-text-grey is-size-7">{{
            nuevoPaquete.codigo_paquete
          }}</span>
        </p>
        <b-field grouped group-multiline class="mt-2">
          <b-field label="Unidades del producto detal" expanded>
            <b-input
              type="number"
              step="0.01"
              min="0.01"
              v-model="nuevoPaquete.cantidad_base"
              placeholder="Ej: 10"
            ></b-input>
          </b-field>
          <b-field label="Cantidad de productos empaquetados" expanded>
            <b-input
              type="number"
              step="1"
              min="1"
              v-model="nuevoPaquete.cantidad_paquete"
              placeholder="Ej: 1"
            ></b-input>
          </b-field>
        </b-field>
        <div
          class="is-size-7 mb-2"
          v-if="nuevoPaquete.cantidad_base && nuevoPaquete.cantidad_paquete"
        >
          <div class="has-text-grey">
            Este producto es el producto detal: el que se vende suelto
            (<strong>{{ producto.nombre }}</strong>). El producto empaquetado que se abre
            es <strong>{{ nuevoPaquete.nombre_paquete }}</strong>.
          </div>
          <div class="has-text-success">
            Al vender más de lo que haya del producto detal se abrirá 1 producto
            empaquetado {{ nuevoPaquete.nombre_paquete }} y sumará
            {{ nuevoPaquete.cantidad_base }} {{ producto.unidad || "unidad" }} del producto
            detal (1 producto empaquetado =
            {{
              unidadesPorEnvaseDe(
                nuevoPaquete.cantidad_base,
                nuevoPaquete.cantidad_paquete
              )
            }}
            {{ producto.unidad || "unidad" }}).
          </div>
          <div
            class="has-text-danger"
            v-if="
              unidadesPorEnvaseDe(
                nuevoPaquete.cantidad_base,
                nuevoPaquete.cantidad_paquete
              ) < 1
            "
          >
            ⚠ Con estos valores un producto empaquetado rinde menos de 1 unidad del
            producto detal y no podrá reponerlo. Si querías "<em
              >N productos empaquetados = M unidades</em
            >", intercambia las cantidades o crea la relación desde el producto que se
            vende suelto.
          </div>
        </div>
        <div
          v-if="nuevoPaquete.paquetes_de"
          class="has-text-warning is-size-7 mb-2"
        >
          ⚠ Este producto ya es producto empaquetado de otro y no puede agregarse como
          producto empaquetado aqu&iacute;.
        </div>
        <b-button
          type="is-primary"
          size="is-small"
          icon-left="plus"
          @click="agregarPaquete"
          :disabled="
            !nuevoPaquete.id_paquete ||
            !nuevoPaquete.cantidad_base ||
            !nuevoPaquete.cantidad_paquete ||
            nuevoPaquete.paquetes_de
          "
        >
          Agregar producto empaquetado
        </b-button>
      </div>
    </div>

    <div v-else class="mt-5">
      <hr />
      <b-message type="is-info" size="is-small">
        Guarda el producto primero para gestionar sus paquetes.
      </b-message>
    </div>

    <br />
    <div class="buttons has-text-centered">
      <b-button
        type="is-primary"
        size="is-large"
        icon-left="check"
        @click="registrar"
        >Registrar</b-button
      >
      <b-button
        type="is-dark"
        size="is-large"
        icon-left="cancel"
        tag="router-link"
        to="/inventario"
        >Cancelar</b-button
      >
    </div>
    <errores-component
      :errores="mensajesError"
      v-if="mensajesError.length > 0"
    />
  </section>
</template>
<script>
import HttpService from "../../Servicios/HttpService";
import Utiles from "../../Servicios/Utiles";
import ErroresComponent from "../Extras/ErroresComponent";
import { MAX_CANTIDAD_PRODUCTO, UNIDADES } from "@/consts";
export default {
  name: "FormProducto",
  props: ["productoProp", "editar"],
  components: { ErroresComponent },

  data: () => ({
    categorias: [],
    marcas: [],
    proveedores: [],
    almacenes: [],
    producto: {
      codigo: "",
      nombre: "",
      unidad: null,
      precioCompra: "",
      precioVenta: "",
      precioVenta2: "",
      precioVenta3: "",
      precioVenta4: "",
      precioVenta5: "",
      precioVenta6: "",
      precioVenta7: "",
      existencia: 0,
      vendidoMayoreo: false,
      precioMayoreo: "",
      cantidadMayoreo: 0,
      categoria: null,
      marca: null,
      proveedor: null,
      idAlmacen: null,
    },
    mensajesError: [],
    unidades: Object.entries(UNIDADES),
    maxCantidadProducto: MAX_CANTIDAD_PRODUCTO,
    paquetes: [],
    /** Relación que se está corrigiendo (null si no hay panel de edición abierto). */
    paqueteEnEdicion: null,
    nuevoPaquete: {
      busqueda: "",
      id_paquete: null,
      nombre_paquete: "",
      codigo_paquete: "",
      cantidad_base: null,
      cantidad_paquete: 1,
      paquetes_de: null,
    },
    productosParaPaquete: [],
  }),

  mounted() {
    this.obtenerCategorias();
    this.obtenerMarcas();
    this.obtenerProveedores();
    this.obtenerAlmacenes();
    if (this.productoProp) {
      this.producto = { ...this.productoProp };
      this.producto.vendidoMayoreo = this.productoProp.vendidoMayoreo === 1;
      this.producto.cantidadMayoreo = parseInt(
        this.productoProp.cantidadMayoreo
      );
      this.producto.idAlmacen = this.productoProp.idAlmacen ? parseInt(this.productoProp.idAlmacen) : null;
      if (Array.isArray(this.productoProp.paquetes)) {
        this.paquetes = this.productoProp.paquetes;
      }
    }
  },

  methods: {
    registrar() {
      let producto = {
        Código: this.producto.codigo,
        Nombre: this.producto.nombre,
        "Precio compra": this.producto.precioCompra,
        "Precio venta": this.producto.precioVenta,
        Proveedor: this.producto.proveedor,
      };

      if (this.editar) {
        producto.Existencia = this.producto.existencia;
      }

      this.mensajesError = Utiles.validarDatos(producto);
      if (
        parseFloat(this.producto.precioVenta) <
        parseFloat(this.producto.precioCompra)
      ) {
        this.mensajesError.push(
          "El precio de venta debe ser mayor al precio compra"
        );
      }
      if (this.mensajesError.length > 0) return;

      if (!this.producto.vendidoMayoreo) {
        this.producto.cantidadMayoreo = "";
      }

      this.$emit("registrado", this.producto);
      this.producto = {
        codigo: "",
        nombre: "",
        precioCompra: "",
        precioVenta: "",
        precioVenta2: "",
        precioVenta3: "",
        precioVenta4: "",
        precioVenta5: "",
        precioVenta6: "",
        precioVenta7: "",
        existencia: 0,
        vendidoMayoreo: false,
        precioMayoreo: "",
        cantidadMayoreo: 0,
        categoria: "",
        marca: "",
        idAlmacen: null,
      };
    },

    obtenerMarcas() {
      let payload = {
        accion: "obtener",
      };
      HttpService.obtenerConConsultas("marcas.php", payload).then((marcas) => {
        this.marcas = marcas;
      });
    },

    obtenerCategorias() {
      let payload = {
        accion: "obtener",
      };
      HttpService.obtenerConConsultas("categorias.php", payload).then(
        (categorias) => {
          this.categorias = categorias;
        }
      );
    },

    obtenerProveedores() {
      let payload = {
        accion: "obtener",
      };
      HttpService.obtenerConConsultas("proveedores.php", payload).then(
        (proveedores) => {
          this.proveedores = proveedores;
        }
      );
    },

    obtenerAlmacenes() {
      let payload = { accion: "obtener" };
      HttpService.obtenerConConsultas("almacenes.php", payload).then(
        (almacenes) => {
          this.almacenes = almacenes || [];
        }
      );
    },

    obtenerPaquetes() {
      if (!this.producto.id) return;
      let payload = {
        accion: "listar_paquetes",
        id_producto_base: this.producto.id,
      };
      HttpService.obtenerConConsultas("productos.php", payload).then(
        (paquetes) => {
          this.paquetes = paquetes;
        }
      );
    },

    buscarProductosParaPaquete() {
      if (!this.nuevoPaquete.busqueda || !this.nuevoPaquete.busqueda.trim()) {
        this.productosParaPaquete = [];
        return;
      }
      let payload = {
        accion: "obtener_nombre_codigo",
        producto: this.nuevoPaquete.busqueda,
      };
      HttpService.obtenerConConsultas("productos.php", payload).then(
        (productos) => {
          this.productosParaPaquete = (productos || []).filter((p) => {
            if (p.id === this.producto.id) return false;
            if (this.paquetes.some((pq) => pq.id_paquete === p.id))
              return false;
            return true;
          });
        }
      );
    },

    seleccionarProductoPaquete(opcion) {
      if (!opcion) return;
      this.nuevoPaquete.id_paquete = opcion.id;
      this.nuevoPaquete.nombre_paquete = opcion.nombre;
      this.nuevoPaquete.codigo_paquete = opcion.codigo;
      this.nuevoPaquete.paquetes_de = opcion.paquetes_de || null;
    },

    /**
     * Unidades del detalle que rinde un envase con las cantidades escritas en el form.
     * Debe ser >= 1: es la misma cuenta que hace el backend para desempaquetar.
     */
    unidadesPorEnvaseDe(cantidadBase, cantidadPaquete) {
      const paquete = parseFloat(cantidadPaquete) || 0;
      const base = parseFloat(cantidadBase) || 0;

      if (paquete <= 0) return 0;

      return Utiles.redondearCantidad(base / paquete);
    },

    agregarPaquete() {
      if (!this.nuevoPaquete.id_paquete || !this.nuevoPaquete.cantidad_base)
        return;

      // Se valida aquí también para no esperar el viaje al servidor: el backend aplica la
      // misma regla y rechazaría la relación.
      const unidades = this.unidadesPorEnvaseDe(
        this.nuevoPaquete.cantidad_base,
        this.nuevoPaquete.cantidad_paquete
      );

      if (unidades < 1) {
        this.$buefy.toast.open({
          type: "is-danger",
          message:
            "Un producto empaquetado no puede rendir menos de 1 unidad del producto detal. Revisa si invertiste el producto detal y el producto empaquetado.",
        });
        return;
      }

      let payload = {
        accion: "agregar_paquete",
        id_producto_base: this.producto.id,
        id_paquete: this.nuevoPaquete.id_paquete,
        cantidad_base: this.nuevoPaquete.cantidad_base,
        cantidad_paquete: this.nuevoPaquete.cantidad_paquete || 1,
      };
      HttpService.registrar("productos.php", payload).then((resultado) => {
        // El API responde {success, error}: un objeto con success=false es truthy, así que
        // hay que mirar el campo y mostrar el motivo real del rechazo.
        if (resultado && resultado.success === true) {
          this.$buefy.toast.open({
            type: "is-info",
            message:
              "Producto empaquetado agregado: 1 " +
              this.nuevoPaquete.nombre_paquete +
              " = " +
              unidades +
              " " +
              (this.producto.unidad || "unidad") +
              " del producto detal",
          });
          this.nuevoPaquete = {
            busqueda: "",
            id_paquete: null,
            nombre_paquete: "",
            codigo_paquete: "",
            cantidad_base: null,
            cantidad_paquete: 1,
            paquetes_de: null,
          };
          this.productosParaPaquete = [];
          this.obtenerPaquetes();
        } else {
          this.$buefy.toast.open({
            type: "is-danger",
            message: (resultado && resultado.error) || "Error al agregar el producto empaquetado.",
          });
        }
      });
    },

    /** Abre la corrección de una relación existente (permite arreglar invertidas). */
    editarPaquete(paquete) {
      this.paqueteEnEdicion = {
        id: paquete.id,
        id_producto_base: paquete.id_producto_base,
        nombre_base: this.producto.nombre,
        id_paquete: paquete.id_paquete,
        nombre_paquete: paquete.nombre_paquete,
        cantidad_base: paquete.cantidad_base,
        cantidad_paquete: paquete.cantidad_paquete,
      };
    },

    cancelarEdicionPaquete() {
      this.paqueteEnEdicion = null;
    },

    /**
     * Intercambia producto al detal y envase manteniendo las cantidades.
     * Es lo que arregla una relación guardada al revés, pero el usuario SIEMPRE ve el
     * resultado antes de guardar: no se corrige nada por detrás.
     */
    intercambiarDetalleYEnvase() {
      if (!this.paqueteEnEdicion) return;

      const edicion = this.paqueteEnEdicion;

      [
        edicion.id_producto_base,
        edicion.id_paquete,
      ] = [edicion.id_paquete, edicion.id_producto_base];

      [
        edicion.nombre_base,
        edicion.nombre_paquete,
      ] = [edicion.nombre_paquete, edicion.nombre_base];
    },

    guardarEdicionPaquete() {
      if (!this.paqueteEnEdicion) return;

      const edicion = this.paqueteEnEdicion;
      const unidades = this.unidadesPorEnvaseDe(
        edicion.cantidad_base,
        edicion.cantidad_paquete
      );

      if (unidades < 1) {
        this.$buefy.toast.open({
          type: "is-danger",
          message:
            "Un envase no puede rendir menos de 1 unidad. Intercambia el detalle y el envase o corrige las cantidades.",
        });
        return;
      }

      const payload = {
        accion: "editar_paquete",
        id: edicion.id,
        id_producto_base: edicion.id_producto_base,
        id_paquete: edicion.id_paquete,
        cantidad_base: edicion.cantidad_base,
        cantidad_paquete: edicion.cantidad_paquete,
      };

      HttpService.registrar("productos.php", payload).then((resultado) => {
        if (resultado && resultado.success === true) {
          this.$buefy.toast.open({
            type: "is-info",
            message:
              "Vinculación corregida: 1 producto empaquetado " +
              edicion.nombre_paquete +
              " = " +
              unidades +
              " " +
              edicion.nombre_base,
          });
          this.paqueteEnEdicion = null;
          this.obtenerPaquetes();
        } else {
          this.$buefy.toast.open({
            type: "is-danger",
            message: (resultado && resultado.error) || "No se pudo corregir la relación.",
          });
        }
      });
    },

    eliminarPaquete(id) {
      this.$buefy.dialog.confirm({
        title: "Eliminar producto empaquetado",
        message: "¿Seguro que deseas eliminar este producto empaquetado?",
        confirmText: "Sí, eliminar",
        cancelText: "Cancelar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          let payload = { accion: "eliminar_paquete", id };
          HttpService.eliminar("productos.php", payload).then((resultado) => {
            if (resultado) {
              this.$buefy.toast.open({
                type: "is-info",
                message: "Producto empaquetado eliminado con éxito.",
              });
              this.obtenerPaquetes();
            } else {
              this.$buefy.toast.open({
                type: "is-danger",
                message: "Error al eliminar el producto empaquetado.",
              });
            }
          });
        },
      });
    },
  },
};
</script>